import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import routes from 'routes';
import { logout } from 'api/authApi';
import styles from './ProfileMenu.module.css';
import SimpleProfile from 'components/common/SimpleProfile';
import ChangePasswordModal from 'components/personal/ChangePasswordModal';
import { useDispatch } from 'react-redux';
import { logout as logoutSlice } from 'services/user/userSlice';

const ProfileMenu = ({ user }) => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [pwOpen, setPwOpen] = useState(false);
  const menuRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showMenu) {
      const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
          setShowMenu(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showMenu]);

  const handleLogout = () => {
    logout().then(() => {
      dispatch(logoutSlice());
      navigate(routes.client.home);
    });
  };

  return (
    <div ref={menuRef} className={styles.profileDropdown}>
      <SimpleProfile
        user={user}
        onClick={() => setShowMenu(!showMenu)}
        isActive={showMenu}
      />
      {showMenu && (
        <div className={styles.profileMenu}>
          <button
            className={styles.profileMenuItem}
            onClick={(e) => {
              e.preventDefault();
              navigate(routes.personal.profile);
              setShowMenu(false);
            }}
          >
            My Profile
          </button>
          <button
            className={styles.profileMenuItem}
            onClick={(e) => {
              e.preventDefault();
              setShowMenu(false);
              setPwOpen(true);
            }}
          >
            Reset my password
          </button>
          <button
            className={styles.profileMenuItem}
            onClick={(e) => {
              e.preventDefault();
              handleLogout();
            }}
          >
            Logout
          </button>
        </div>
      )}
      <ChangePasswordModal isOpen={pwOpen} onClose={() => setPwOpen(false)} />
    </div>
  );
};

ProfileMenu.propTypes = {
  user: PropTypes.object,
};

export default ProfileMenu;
